export default "__VITE_ASSET__r2VMqHaP__"